const CONTROL_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
].join(', ');

function isKeyboardActivation(event) {
    return event.detail === 0;
}

function follows(element, candidate) {
    return element.compareDocumentPosition(candidate) === Node.DOCUMENT_POSITION_FOLLOWING;
}

function focusFirstControlAfter(element) {
    const { ownerDocument } = element;

    Array.from(ownerDocument.querySelectorAll(CONTROL_SELECTOR))
        .filter(control => follows(element, control))
        .some((control) => {
            control.focus();

            return ownerDocument.activeElement === control;
        });
}

export default function dismissKeepingKeyboardFocus(dismiss, dismissedRef) {
    return (event) => {
        if (isKeyboardActivation(event)) {
            focusFirstControlAfter(dismissedRef.current);
        }
        dismiss();
    };
}
